import { BusinessAdminScreen } from "@/features/organization/BusinessAdminScreen";

/**
 * La ruta /brand ahora renderiza la pantalla integral de Configuración
 * donde cada negocio gestiona su apariencia, colores, tipografía, diseño de ticket,
 * datos fiscales, operaciones, usuarios y sucursales.
 */
export function BrandScreen() {
  return <BusinessAdminScreen />;
}
